import * as Service from 'types/service';

export interface FunctionTypes {
  closeWalkInPanel(): BaseTockAction;
  openWalkInPanel(walkInType: Service.WalkInType): BaseTockAction;
  setLatestQuotedTime(latestQuotedTimeMin: string): BaseTockAction;
}

export function closeWalkInPanel(): BaseTockAction {
  return {
    type: 'CLOSE_WALK_IN_PANEL',
  };
}

export function openWalkInPanel(walkInType: Service.WalkInType): BaseTockAction {
  return {
    type: 'OPEN_WALK_IN_PANEL',
    payload: walkInType,
    context: {
      shouldTrack: true,
      keyToTrack: 'payload',
    },
  };
}

interface OpenWalkInPanelForEditingOptions {
  walkInType: Service.WalkInType;
  walkInParty: Service.Party;
}

// passing in no arguments is legal, but is passing in one argument?
export function openWalkInPanelForEditing(
  options?: OpenWalkInPanelForEditingOptions
): BaseTockAction {
  const payload = options ? { party: options.walkInParty, type: options.walkInType } : {};
  return {
    type: 'OPEN_WALK_IN_PANEL_FOR_EDITING',
    payload,
    context: {
      shouldTrack: true,
    },
  };
}

export function setLatestExpectedReservationTime(
  latestExpectedReservationTime: string
): BaseTockAction {
  return {
    type: 'SET_LATEST_EXPECTED_RESERVATION_TIME',
    payload: latestExpectedReservationTime,
  };
}

export function setLatestQuotedTime(latestQuotedTimeMin: string): BaseTockAction {
  return {
    type: 'SET_LATEST_QUOTED_TIME',
    payload: latestQuotedTimeMin,
  };
}
